import React from "react";

const BranchFormTabs = ({ tabs, activeTab, setActiveTab }) => {
  const tabLabels = {
    basic: "Basic",
    address: "Address",
    contact: "Contact",
    rates: "Rates",
    settings: "Settings",
    compliance: "Compliance",
    financial: "Financial",
    hours: "Working Hours",
  };

  return (
    <div className="mt-4 flex gap-4 overflow-x-auto border-b">
      {tabs.map((tab) => (
        <button
          key={tab}
          type="button"
          onClick={() => setActiveTab(tab)}
          className={`pb-2 px-1 capitalize font-medium border-b-2 transition-colors whitespace-nowrap ${
            activeTab === tab
              ? "border-blue-600 text-blue-600"
              : "border-transparent text-gray-600 hover:text-gray-900"
          }`}
        >
          {tabLabels[tab] || tab}
        </button>
      ))}
    </div>
  );
};

export default BranchFormTabs;
